module.exports = __webpack_public_path__ + "static/media/Introduksjon-sprakforstaelse.0cbb7f89.mp3";